import classNames from "classnames";
import type { ReactNode } from "react";

interface NavigationButtonProps {
    children: ReactNode;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    /** Whether button appears active */
    isActive?: boolean;
    /** Style variant */
    variant?: "default" | "book";
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Button styled to look like a navigation link
 * Used for actions like opening notifications, help menu, etc.
 */
const NavigationButton = ({
    children,
    onClick,
    isActive = false,
    variant = "default",
    className,
    style,
}: NavigationButtonProps) => {
    return (
        <button
            className={classNames("navigation-link", "navigation-button", className, {
                "navigation-link--book": variant === "book",
                "navigation-button--active": isActive,
            })}
            onClick={onClick}
            style={style}
        >
            {children}
        </button>
    );
};

export default NavigationButton;
